import CertificationsModule from './containers/certificationsModule'

export {default as CertificationsModuleLayout} from './components/certificationsModuleLayout'

export default CertificationsModule
